var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenarioEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.99999L2 22M18 15H9M6.6 19H13.3373C13.5818 19 13.7041 19 13.8192 18.9724C13.9213 18.9479 14.0188 18.9075 14.1083 18.8526C14.2092 18.7908 14.2957 18.7043 14.4686 18.5314L19.5 13.5C19.739 13.261 19.8584 13.1416 19.9546 13.0358C22.0348 10.7473 22.0348 7.25267 19.9546 4.96422C19.8584 4.85844 19.739 4.73896 19.5 4.49999C19.261 4.26103 19.1416 4.14155 19.0358 4.04539C16.7473 1.96524 13.2527 1.96524 10.9642 4.04539C10.8584 4.14155 10.739 4.26103 10.5 4.49999L5.46863 9.53136C5.29568 9.70432 5.2092 9.79079 5.14736 9.89171C5.09253 9.98118 5.05213 10.0787 5.02763 10.1808C5 10.2958 5 10.4181 5 10.6627V17.4C5 17.96 5 18.2401 5.10899 18.454C5.20487 18.6421 5.35785 18.7951 5.54601 18.891C5.75992 19 6.03995 19 6.6 19Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenarioEdit);
export default __webpack_public_path__ + "static/media/scenario_edit.5a72cde6df66fc07da479c4e511c4ef6.svg";
export { ForwardRef as ReactComponent };